import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';

// A custom theme for this app
const theme = createTheme({
  palette: {
    primary: {
      // c3 green
      main: '#387728',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
  },  
  components: {
    MuiButton: {
      defaultProps: {
        // from above defined colors
        color: 'primary',
        
      },
    }
  }
});

export default theme;
